import React from 'react';
import { Calendar, ShoppingBag, Phone, ExternalLink } from 'lucide-react';

const PrenotaSection = () => {
  const bookingOptions = [
    {
      icon: Calendar,
      title: 'Prenota un Tavolo',
      description: 'Riserva il tuo posto al ristorante',
      link: 'https://pnssm.pro/ms4ii86',
      color: 'bg-[#7f9e60]',
      hoverColor: 'hover:bg-[#6a8550]',
    },
    {
      icon: ShoppingBag,
      title: 'Asporto & Domicilio',
      description: 'Ordina comodamente da casa tua',
      link: 'https://pnssm.pro/y8n0ytd',
      color: 'bg-gray-800',
      hoverColor: 'hover:bg-gray-700',
    },
    {
      icon: Phone,
      title: 'Chiama Direttamente',
      description: '+39 347 167 4689',
      link: 'tel:+393471674689',
      color: 'bg-amber-600',
      hoverColor: 'hover:bg-amber-700',
    },
  ];

  return (
    <section id="prenota" className="py-24 bg-[#7f9e60]">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="text-5xl md:text-6xl font-bold text-white mb-4" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
              Prenota la Tua Esperienza
            </h2>
            <p className="text-xl text-white/90 max-w-2xl mx-auto">
              Scegli come preferisci goderti la cucina di Grano e Sale
            </p>
            <div className="w-24 h-1 bg-white mx-auto rounded-full mt-6"></div>
          </div>

          {/* Booking Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {bookingOptions.map((option, index) => (
              <a
                key={index}
                href={option.link}
                target={option.link.startsWith('http') ? '_blank' : '_self'}
                rel="noopener noreferrer"
                className={`group ${option.color} ${option.hoverColor} rounded-2xl p-8 text-white transition-all duration-300 hover:scale-105 hover:shadow-2xl`}
              >
                <div className="flex flex-col items-center text-center space-y-4">
                  <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center group-hover:bg-white/30 transition-colors">
                    <option.icon size={36} />
                  </div>
                  <h3 className="text-2xl font-bold" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
                    {option.title}
                  </h3>
                  <p className="text-white/90">
                    {option.description}
                  </p>
                  <div className="flex items-center space-x-2 text-white/80 group-hover:text-white transition-colors">
                    <span className="font-semibold">Clicca qui</span>
                    <ExternalLink size={18} className="group-hover:translate-x-1 transition-transform" />
                  </div>
                </div>
              </a>
            ))}
          </div>

          {/* VIP Card Promo */}
          <div className="mt-12 bg-white/10 backdrop-blur-sm rounded-2xl p-8 border-2 border-white/20">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <div className="text-center md:text-left">
                <h3 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
                  Programma Fedeltà VIP Card
                </h3>
                <p className="text-white/90">
                  Accumula punti e ricevi vantaggi esclusivi ad ogni visita
                </p>
              </div>
              <a
                href="https://pnssm.pro/0hmi23g"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-white text-[#7f9e60] font-bold rounded-full hover:bg-gray-100 transition-all hover:scale-105 whitespace-nowrap"
              >
                Registrati Gratis
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrenotaSection;
